import { render, staticRenderFns } from "./left-bottom.vue?vue&type=template&id=28d60c58&scoped=true&"
import script from "./left-bottom.vue?vue&type=script&lang=js&"
export * from "./left-bottom.vue?vue&type=script&lang=js&"
import style0 from "./left-bottom.vue?vue&type=style&index=0&id=28d60c58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d60c58",
  null
  
)

export default component.exports